import { tokens } from "@opendoor/tokens-studio/dist/bricks-next/tokens/Components";
import { getTokenValue, styled, useProps } from "@tamagui/core";
import { getRGBA } from "../../helpers/convertColor";
import { getOpacityTokenValue } from "../../helpers/tokens";
import { Box } from "../Box";
import { Text } from "../Text";
import { jsx } from "react/jsx-runtime";
const BoxWithRgbaBackground = styled(Box, {
  variants: {
    backgroundColorVariant: (variant) => {
      const { pill: pillTokens } = tokens;
      return variant !== "inverse" ? { backgroundColor: pillTokens.color.background[variant] } : { backgroundColor: getRGBA(
        getTokenValue(pillTokens.color.background.default, "color"),
        getOpacityTokenValue(pillTokens.opacity.backgroundInverse)
      ) };
    }
  }
}), Pill = ({
  label,
  rounded,
  variant = "default",
  weight = "regularWeight",
  "data-testid": dataTestId,
  ...props
}) => {
  const { pill: pillTokens } = tokens, { size = "medium" } = useProps(props), sizeToken = size === "xsmall" ? "small" : size;
  return /* @__PURE__ */ jsx(
    BoxWithRgbaBackground,
    {
      alignItems: "center",
      justifyContent: "center",
      backgroundColorVariant: variant,
      borderColor: pillTokens.color.border[variant],
      borderRadius: rounded ? pillTokens.cornerRadius.rounded : pillTokens.cornerRadius[sizeToken],
      borderWidth: pillTokens.borderWidth.default,
      height: size === "xsmall" ? "auto" : pillTokens.size.height[weight][`${sizeToken}Size`],
      paddingBottom: size === "medium" ? pillTokens.padding.medium.bottom[weight] : pillTokens.padding.small.topBottom[weight],
      paddingHorizontal: pillTokens.padding[sizeToken].rightLeft,
      paddingTop: size === "medium" ? pillTokens.padding.medium.top[weight] : pillTokens.padding.small.topBottom[weight],
      width: "max-content",
      "data-testid": dataTestId,
      children: /* @__PURE__ */ jsx(
        Text,
        {
          tag: "span",
          typography: size === "xsmall" ? "$bodyXsmall" : pillTokens.typography[weight][size],
          fontWeight: weight === "mediumWeight" ? "$medium" : "$regular",
          color: pillTokens.color.content.label[variant === "black" ? "inverse" : variant],
          children: label
        }
      )
    }
  );
};
export {
  Pill
};
